module.exports = __webpack_public_path__ + "static/media/peterson_depue.55f78d75.jpg";